import React, { FC } from 'react';
import { useField } from 'formik';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';

export const CityFilter: FC = () => {
  const [field, meta] = useField<string>({ name: 'city' });

  return (
    <FormField
      label={<Label>City</Label>}
      control={<Input {...field} autoComplete={'off'} />}
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
